import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PromotionCard from '../../components/promotions/PromotionCard'
import PromotionHeaderTab from '../../components/promotions/PromotionHeaderTab'
import Text from '../../components/text/Text'
import { useLoadingContext } from '../../context/spinnerContext'
import routes from '../../router/routes'
import {
    deletePromotion,
    getAllPromotions,
    getOnePromotion,
} from '../../services/promotions'
import './PromotionMain.css'
import { PromotionInfo } from '../payment/payment'
import PromotionModal from '../../components/modal/PromotionModal'
import { clevertapEvents } from '../../labels'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import { getLocal, getLocalId, isAdmin } from '../../Utils/Profile'

const PromotionMain = () => {
    const loadingContext = useLoadingContext()

    const navigate = useNavigate()
    const [activeTag, setActiveTag] = useState<number>(0)
    const [promotionInfo, setPromotionInfo] = useState<PromotionInfo[]>([])
    const [showPromotionModal, setShowPromotionModal] = useState<boolean>(false)
    const [promotionItem, setPromotionItem] = useState<
        PromotionInfo | undefined
    >(undefined)

    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const promotionEventParms = {
        pageName: 'PromotionMain',
        pageURL: routes.home,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    const selectedLocalId = getLocalId()

    const handleOnChangeTab = (tab: number) => {
        setActiveTag(tab)
    }

    const getPromotionsAsync = async () => {
        try {
            loadingContext?.onOpen()
            if (!selectedLocalId)
                throw new Error('No se ha seleccionado un local')

            await getAllPromotions(selectedLocalId)
                .then((resp: any) => {
                    if (resp.length !== 0) {
                        const px = resp.filter(
                            (item: { sEstado: string }) =>
                                item.sEstado !== 'vencida'
                        )
                        console.log('🚀 ~ .then ~ px:', px)
                        setPromotionInfo(resp)
                    }
                    loadingContext?.onClose()
                })
                .catch(() => {
                    loadingContext?.onClose()
                })
        } catch (error) {
            console.log(error)
            loadingContext?.onClose()
        }
    }
    const deletePromotionsAsync = async (idPromocion: string) => {
        track(
            clevertapEvents.amiposweb_atraemasclientes_promociones_eliminar,
            promotionEventParms
        )

        try {
            loadingContext?.onOpen()

            await deletePromotion(
                user.sEstablecimiento,
                getLocal(),
                idPromocion
            ).then((resp: any) => {
                setPromotionInfo((prevPromotions) =>
                    prevPromotions.filter(
                        (promotion) => promotion.idPromocion !== idPromocion
                    )
                )
                loadingContext?.onClose()
            })
        } catch (error) {
            console.log(error)
            loadingContext?.onClose()
        }
    }

    useEffect(() => {
        getPromotionsAsync()
    }, [])

    const avalaiblePromotions = promotionInfo.filter(
        (item) => item.sEstado !== 'vencida'
    )
    const duePromotions = promotionInfo.filter(
        (item) => item.sEstado === 'vencida'
    )

    const handlerShowDetails = (item: any) => {
        loadingContext?.onOpen()
        if (item.sTipo === 'DescuentoSKU') {
            try {
                getOnePromotion(item.idPromocion).then((success: any) => {
                    if (
                        Array.isArray(success) &&
                        success[0]?.commerceStock?.stock
                    ) {
                        setPromotionItem({
                            ...item,
                            stock: success[0].commerceStock?.stock,
                        })
                        loadingContext?.onClose()
                        setShowPromotionModal(true)
                    } else {
                        setPromotionItem(item)
                        loadingContext?.onClose()
                        setShowPromotionModal(true)
                    }
                })
            } catch {
                setPromotionItem(item)
                loadingContext?.onClose()
                setShowPromotionModal(true)
            }
        } else {
            setPromotionItem(item)
            loadingContext?.onClose()
            setShowPromotionModal(true)
        }
    }

    return (
        <div>
            <Text
                label="Listado de promociones:"
                fontWeight={400}
                fontSize={27}
                color={'#184287'}
                marginBottom={20}
            />
            <div className="background-promotion-parent">
                <div className="all-promotion-container">
                    <PromotionHeaderTab
                        onChangeTab={handleOnChangeTab}
                        activeTab={activeTag}
                    />

                    {activeTag === 0 &&
                        (avalaiblePromotions.length > 0 ? (
                            avalaiblePromotions.map((item) => (
                                <PromotionCard
                                    key={item.sPromocion + item.nDescuento}
                                    idPromocion={item.idPromocion}
                                    promoName={item.sPromocion}
                                    fromDate={item.dInicio}
                                    toDate={item.dTermino}
                                    validFor={
                                        item.bTiendaOnline
                                            ? 'Compras online'
                                            : 'Compras presenciales'
                                    }
                                    onClick={() => {
                                        handlerShowDetails(item)
                                    }}
                                    deletePromotion={() =>
                                        deletePromotionsAsync(item.idPromocion)
                                    }
                                />
                            ))
                        ) : (
                            <div className="promotion-blue-box-container">
                                <Text
                                    label={`No tienes publicada ninguna\npromoción actualmente ☹️`}
                                    fontWeight={600}
                                    fontSize={20}
                                    color={'#565656'}
                                    fontFamily={'Poppins'}
                                />
                            </div>
                        ))}

                    {activeTag === 1 &&
                        (duePromotions.length > 0 ? (
                            duePromotions.map((item) => (
                                <PromotionCard
                                    key={item.sPromocion + item.nDescuento}
                                    idPromocion={item.idPromocion}
                                    promoName={item.sPromocion}
                                    fromDate={item.dInicio}
                                    toDate={item.dTermino}
                                    validFor={
                                        item.bTiendaOnline
                                            ? 'Compras online'
                                            : 'Compras presenciales'
                                    }
                                    onClick={() => {
                                        handlerShowDetails(item)
                                    }}
                                    deletePromotion={() =>
                                        deletePromotionsAsync(item.idPromocion)
                                    }
                                />
                            ))
                        ) : (
                            <div className="promotion-blue-box-container">
                                <Text
                                    label={`No tienes publicada ninguna\npromoción actualmente ☹️`}
                                    fontWeight={600}
                                    fontSize={20}
                                    color={'#565656'}
                                    fontFamily={'Poppins'}
                                />
                            </div>
                        ))}
                </div>

                {isAdmin() && (
                    <div
                        className="promotion-create-promotion-button"
                        onClick={() => {
                            track(
                                clevertapEvents.amiposweb_atraemasclientes_promociones_crearpromocion,
                                promotionEventParms
                            )
                            navigate(`/${routes.createPromotion}`)
                        }}
                    >
                        <Text label="Crear una nueva promoción" color="white" />
                    </div>
                )}
            </div>
            {promotionItem && (
                <PromotionModal
                    promotionInfo={promotionItem}
                    showPromotionModal={showPromotionModal}
                    setShowPromotionModal={setShowPromotionModal}
                    title="Detalle Promoción"
                    marginLeftTitle={50}
                    btnCobrar={false}
                />
            )}
        </div>
    )
}
export default PromotionMain
